"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.echainSystemFromIproSystemRefKuerzel = exports.echainSystemFromAkeneoAttribute = exports.EchainSystemToIproSystemKuerzel = exports.EchainSystemToAkeneoAttributeCode = void 0;
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
exports.EchainSystemToAkeneoAttributeCode = {
    E2_1: ['e2_1'],
    E1: ['e1_echain'],
    E2000_medium: ['e2000_medium'],
    E2000_medium_esd: ['e2000_esd_medium'],
    E2000_medium_tube: ['e2000_medium_etube'],
    E2000_rol: ['e2_000_role_echain'],
    E2_R100_tube: ['e2_r100_etube'],
    E2_R_tube: ['e2_r_etube'],
    E2_medium: ['e2_medium'],
    E2_micro: ['e2_micro'],
    E2_micro_esd: ['e2_micro_esd'],
    E2_mini: ['e2_mini'],
    E3: ['e3_echain'],
    E4_0: ['e4_0_echain'],
    E4_00: ['e4_00_echain'],
    E4_00_tube: ['e4_00_etube'],
    E4_0_tube: ['e4_0_etube'],
    E4_1: ['e4_1_echain'],
    E4_1_esd: ['e4_1_esd_echain'],
    E4_1_light: ['e4_1_light'],
    E4_1_light_tube: ['e4_1_l_etube'],
    E4_1_tube: ['e4_1_etube'],
    E4_4: ['e4_4_echain'],
    E4_4_tube: ['e4_4_etube'],
    E4_4_rol: ['e4_4_role_echain'],
    E4_4_hd_rol: ['e4_4_hd_role_echain'],
    R4_4_rol: ['r4_4_role_etube'],
    E4_Q: ['e4_q'],
    E4_light: ['e4_light_echain'],
    E4_light_esd: ['e4_light_esd_echain'],
    E4_light_tube: ['e4_light_etube'],
    E6: ['e6_echain'],
    E6_esd: undefined,
    E6_1: ['e6_1_echain'],
    E6_R_tube: ['e6_r_etube'],
    Easy_chain: ['Easy_Chain'],
    Easy_triflex: ['easy_triflex'],
    Eskin: ['e_skin'],
    Espool: ['e_spool'],
    P4: ['system_p4'],
    P41: ['system_p41'],
    R2_1_tube: ['r2_1_etube'],
    Rx_tube: ['rx_tube'],
    T3: ['system_t3'],
    Triflex: ['triflex'],
    Triflex_R_TRC: ['triflex_R_TRC'],
    Triflex_R_TRE: ['triflex_R_TRE'],
    Triflex_R_TRL: ['triflex_R_TRL'],
    Triflex_R_TRXE: ['triflex_R_TRXE'],
    Twisterband: ['twisterband'],
    Twisterchain: ['twisterchain'],
    Twisterchain_new: ['twisterchain_new'],
    Ye: ['ye_echain'],
    Zipper: ['zipper_echain'],
    Zipper_esd: ['zipper_esd'],
    Zipper_tube: ['zipper_tube'],
};
exports.EchainSystemToIproSystemKuerzel = {
    E2_1: ['E_2_1_Energiekette'],
    E1: ['E1_E-Ketten'],
    E2000_medium: ['E2_000_medium_E-Ketten'],
    E2000_medium_esd: ['E2_000_ESD_medium_E-Ketten'],
    E2000_medium_tube: ['E2_000_medium_Energierohre'],
    E2000_rol: undefined,
    E2_R100_tube: ['E2_R100_Energierohre'],
    E2_R_tube: ['E2_R_Energierohre'],
    E2_medium: ['E2_medium_E-Ketten'],
    E2_micro: ['E2_micro_E-Ketten'],
    E2_micro_esd: ['E2_micro_ESD_E-Ketten'],
    E2_mini: ['E2_mini_E-Ketten'],
    E3: ['E3_E-Ketten'],
    E4_0: ['E4_0_E-Ketten'],
    E4_0_tube: ['E4_0_Energierohre'],
    E4_00: ['E4_00_E-Ketten'],
    E4_00_tube: ['E4_00_Energierohre'],
    E4_1: ['E4-1_E-Ketten'],
    E4_1_esd: ['E4-1_ESD_E-Ketten'],
    E4_1_light: ['E4-1_light_E-Ketten'],
    E4_1_light_tube: ['E4-1_light_E-Rohre'],
    E4_1_tube: ['E4-1_Energierohre'],
    E4_4: ['E4_4_E-Ketten'],
    E4_4_tube: ['E4_4_Energierohre'],
    E4_4_rol: undefined,
    E4_4_hd_rol: undefined,
    R4_4_rol: undefined,
    E4_Q: ['E4Q_E-Ketten'],
    E4_light: ['E4_light_E-Ketten'],
    E4_light_esd: ['E4_light_ESD_E-Ketten'],
    E4_light_tube: ['E4_light_Energierohre'],
    E6: ['E6_E-Ketten'],
    E6_esd: ['E6_ESD_E-Ketten'],
    E6_1: ['E61_E-Ketten'],
    E6_R_tube: ['E6_R_Energierohre'],
    Easy_chain: ['Easy_Chain_E-Ketten'],
    Easy_triflex: ['Easy_Triflex'],
    Eskin: ['e_skin'],
    Espool: ['espool', 'e-spool'],
    P4: ['System_P4'],
    P41: undefined,
    R2_1_tube: ['R_2_1_Energierohre'],
    Rx_tube: ['RX_Rohre'],
    T3: ['System_T3'],
    Triflex: ['Triflex'],
    Triflex_R_TRC: ['Triflex_R_TRC'],
    Triflex_R_TRE: ['Triflex_R_TRE'],
    Triflex_R_TRL: ['Triflex_R_TRL'],
    Triflex_R_TRXE: ['Triflex_R_TRXE'],
    Twisterband: ['System_TwisterBand'],
    Twisterchain: ['TwisterChain'],
    Twisterchain_new: ['TwisterChainNew'],
    Ye: ['YE_Energiekette'],
    Zipper: ['Zipper_E-Ketten'],
    Zipper_esd: ['Zipper_ESD_E-Ketten'],
    Zipper_tube: ['Zipper_Energierohre'],
};
const echainSystemFromAkeneoAttribute = (akeneoAttributeCode) => {
    if (!akeneoAttributeCode)
        return undefined;
    return (0, echain_shared_ts_utils_1.getObjectKeys)(exports.EchainSystemToAkeneoAttributeCode).find((key) => { var _a; return (_a = exports.EchainSystemToAkeneoAttributeCode[key]) === null || _a === void 0 ? void 0 : _a.includes(akeneoAttributeCode); });
};
exports.echainSystemFromAkeneoAttribute = echainSystemFromAkeneoAttribute;
const echainSystemFromIproSystemRefKuerzel = (systemRefKuerzel) => {
    if (!systemRefKuerzel)
        return undefined;
    return (0, echain_shared_ts_utils_1.getObjectKeys)(exports.EchainSystemToIproSystemKuerzel).find((key) => { var _a; return (_a = exports.EchainSystemToIproSystemKuerzel[key]) === null || _a === void 0 ? void 0 : _a.includes(systemRefKuerzel); });
};
exports.echainSystemFromIproSystemRefKuerzel = echainSystemFromIproSystemRefKuerzel;
//# sourceMappingURL=EchainSystem.js.map